'use client'

import { AppLink } from '@/shared/lib/router'

import { useFeedStore } from '../../stores/useFeedStore'

import { FEED_FULL_PATH, FEED_PREVIEW_LIMIT } from '@/features/profiles/constants/feed-routes'
import { getFeedItemKey } from '@/features/profiles/types/feed'
import { Button } from '@/shared/ui/Button'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle
} from '@/shared/ui/Modal'


import { FeedItem } from './Item'

export const FeedModal = ({ onHide }: { onHide?: () => void }) => {
  const { feed, isSuccess } = useFeedStore()
  const records = isSuccess ? (feed ?? []) : []
  const preview = records.slice(0, FEED_PREVIEW_LIMIT)

  return (
    <Modal asCard variant="dark">
      <ModalHeader>
        <ModalTitle>Notificações</ModalTitle>
      </ModalHeader>
      <ModalBody className="flex flex-col gap-2">
        {preview.map(item => (
          <FeedItem key={getFeedItemKey(item)} item={item} />
        ))}
      </ModalBody>
      <ModalFooter>
        <Button
          as={AppLink}
          href={FEED_FULL_PATH}
          className="w-full"
          onClick={() => {
            onHide?.()
          }}
        >
          Ver mais
        </Button>
      </ModalFooter>
    </Modal>
  )
}
